import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

export default new Vuex.Store({
	state: {
		user: JSON.parse(window.localStorage.getItem('userInfo')),
		submit_order_rarams: JSON.parse(sessionStorage.getItem('submit_order_rarams')),
		common_info: "",
		searchHistory:[],
		public_info:'',
		// common_info: JSON.parse(sessionStorage.getItem('common_info'))
	},
	mutations: {
		// 用户信息
		userInfo(state, data) {
			state.user = data;
			// 为了防止页面刷新数据丢失，我们还需要把数据放到本地存储中，这里仅仅是为了持久化数据
			window.localStorage.setItem('userInfo', JSON.stringify(state.user))
		},
		// 支付
		submitOrderRarams(state, data) {
			state.submit_order_rarams = data;
			window.sessionStorage.setItem('submit_order_rarams', JSON.stringify(data));
		},
		// 头尾公共信息
		commonInfo(state, data) {
			state.common_info = data;
			// window.sessionStorage.setItem('common_info', JSON.stringify(data));
		},
		SET_SEARCH_HISTORY(state, history) {
			state.searchHistory = history
		},
		publicInfo(state,data){
			state.public_info = data;
			window.sessionStorage.setItem('public_info', JSON.stringify(data));
		},
	},
	actions: {},
	modules: {}
})
export const saveSearchHistory = function ({
	commit
  }, query) {
	commit('SET_SEARCH_HISTORY', saveSearch(query))
  }